type GridPosition = { row: number; col: number }

// Intended grid slots for items that haven't reached the files-list query yet.
// Set by producers (DnD drops, new-folder), consumed by the desktop sync.
const positions = new Map<number, GridPosition>()

export const pendingItemPositions = {
  set(itemId: number, position: GridPosition) {
    positions.set(itemId, position)
  },
  consume(itemId: number): GridPosition | undefined {
    const position = positions.get(itemId)
    positions.delete(itemId)
    return position
  },
  delete(itemId: number) {
    positions.delete(itemId)
  }
}

// File IDs optimistically moved off the desktop whose async move job hasn't
// completed yet. The sync excludes these from the "missing items" re-add until
// a refetch confirms they've left the app-root folder.
const moveOutIds = new Set<number>()

export const pendingMoveOutItems = {
  add(fileId: number) {
    moveOutIds.add(fileId)
  },
  remove(fileId: number) {
    moveOutIds.delete(fileId)
  },
  has(fileId: number) {
    return moveOutIds.has(fileId)
  },
  /** Drops IDs no longer in the refetched list; keeps the rest in-flight. */
  reconcile(refetchedFileIds: Set<number>): void {
    for (const id of [...moveOutIds]) {
      if (!refetchedFileIds.has(id)) {
        moveOutIds.delete(id)
      }
    }
  }
}
